import styled from "styled-components";
import {device} from "../styles/responsive/responsiveUtils";

export const StyledAccountSettingsWrapper = styled.div`
  color: ${({theme}) => theme.grayColorText};
  text-align: center;
  ul {
    display: flex;
    justify-content: center;
    li {
      &:not(:last-child) {
        margin-right: 20px;
      }
      button, a {
        border: none;
        outline: none;
        transition: all 0.15s ease-in-out;
        &:hover {
          color: ${({theme}) => theme.accountSettingLink.color};
        }
      }
    }
  }
  
  p {
    text-align: center;
    display: inline-flex;
    justify-content: center;
    transition: all .3s ease;
    cursor: pointer;
    &:hover {
      color: ${({theme}) => theme.accountSettingLink.color};
    }
  }
  
  @media screen and (max-width: 1100px) {
    display: none;
  }
`;

export const StyledClientsChangePassword = styled.div`
  width: 100%;
  .form-change-password {
    display: flex;
    flex-direction: column;
    &__action {
      width: 100%;
      margin: 20px auto 0;
    }
  }
    @media screen and ${device('xs')} {
        .input-group {
            margin-bottom: 0;

            input {
                font-size: 14px;
                height: 32px;
                padding: 3px 5px;
            }
        }
    }
    & .flex-inline {

        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 5px;
        margin-bottom: 15px;

        &.between {
            justify-content: space-between;
        }

        .radio__input, .checkbox__input {
            margin-right: 10px;
            position: absolute;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
        }

        .custom-radio, .custom-checkbox {
            width: 20px;
            height: 20px;
            background-image: url(${({ theme }) => theme.backgroundCheckboxInput});
            background-position: -160px 0;
        }

        .custom-checkbox {
            background-position: -5px 0;
        }

        .radio__input {
            &:checked + .custom-radio {
                background-position: -222px 0;
            }
        }

        .checkbox__input {
            &:checked + .custom-checkbox {
                background-position: -67px 0;
            }
        }

        label {
            z-index: 2;
        }

        label:not(.without-padding) {
            margin-left: -1.5em;
            padding-left: 1.7em;
        }

        .limits-label {
            min-width: 0;

            @media screen and ${device('xs')} {
                min-width: 152px;
            }
        }
    }
`;